import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import ButtonPrimitive from "../Button/primitives";
import { EMPTY_OBJ } from "../helpers/logic/empties";
import Typography from "../Typography";
import CalloutDescription from "./components/CalloutDescription";
import useCalloutContent from "./hooks/useCalloutContent";
import { BaseCallout, BaseCalloutActions, BaseCalloutIconContainer, BaseCalloutTitleContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Callout(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    description = _ref.description,
    actions = _ref.actions,
    _ref$severity = _ref.severity,
    severity = _ref$severity === void 0 ? "info" : _ref$severity,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    hideTitle = _ref.hideTitle;
  var _ref2 = actions || EMPTY_OBJ,
    primary = _ref2.primary,
    secondary = _ref2.secondary;
  var _useCalloutContent = useCalloutContent({
      title: title,
      severity: severity,
      size: size,
      icon: icon
    }),
    titleToDisplay = _useCalloutContent.titleToDisplay,
    titleColor = _useCalloutContent.titleColor,
    iconToDisplay = _useCalloutContent.iconToDisplay,
    iconColor = _useCalloutContent.iconColor,
    spinnerColor = _useCalloutContent.spinnerColor,
    iconSize = _useCalloutContent.iconSize,
    isCompactLayout = _useCalloutContent.isCompactLayout;
  var IconComponent = iconToDisplay;
  var commonButtonProps = {
    color: severity,
    spinnerColor: spinnerColor,
    size: "compact"
  };
  var getTitleContent = function getTitleContent() {
    if (hideTitle) {
      return /*#__PURE__*/_jsx(CalloutDescription, {
        hideTitle: hideTitle,
        size: size,
        severity: severity,
        content: description
      });
    }
    if (size === "compact") {
      return /*#__PURE__*/_jsx(CalloutDescription, {
        hideTitle: hideTitle,
        size: size,
        severity: severity,
        content: description
      });
    }
    if (size === "blockCompact") {
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Typography, {
          color: titleColor,
          variant: "display200",
          children: titleToDisplay
        }), /*#__PURE__*/_jsx(CalloutDescription, {
          hideTitle: hideTitle,
          size: size,
          severity: severity,
          content: description
        })]
      });
    }
    return /*#__PURE__*/_jsx(Typography, {
      color: titleColor,
      variant: "display300",
      children: titleToDisplay
    });
  };
  return /*#__PURE__*/_jsxs(BaseCallout, {
    role: "alert",
    size: size,
    severity: severity,
    children: [/*#__PURE__*/_jsxs(BaseCalloutTitleContainer, {
      size: size,
      css: {
        color: iconColor
      },
      children: [/*#__PURE__*/_jsx(BaseCalloutIconContainer, {
        topNudge: size,
        children: /*#__PURE__*/_jsx(IconComponent, {
          size: iconSize,
          color: "currentColor"
        })
      }), getTitleContent()]
    }), !isCompactLayout && !hideTitle && /*#__PURE__*/_jsx(CalloutDescription, {
      severity: severity,
      content: description
    }), actions && size !== "compact" && /*#__PURE__*/_jsxs(BaseCalloutActions, {
      size: size,
      children: [secondary && /*#__PURE__*/_jsx(ButtonPrimitive, _extends({
        onClick: secondary.onClick,
        variant: "ghost",
        iconRight: secondary.icon,
        isLoading: secondary.isLoading
      }, commonButtonProps, {
        children: secondary.label
      })), primary && /*#__PURE__*/_jsx(ButtonPrimitive, _extends({
        onClick: primary.onClick,
        variant: "solid",
        iconRight: primary.icon,
        isLoading: primary.isLoading
      }, commonButtonProps, {
        children: primary.label
      }))]
    })]
  });
}
export default Callout;